// extracted by mini-css-extract-plugin
module.exports = {"tabActions":"style-module__tabActions___1hURq","end":"style-module__end___1q2MK","spaced":"style-module__spaced___w8VzD"};